
import { executeEntityValidators, ValidationWarnings } from "../../../shared/validation/entity-validation.util";
import { Firearm } from "./firearm.model";


export const firearmAdditionalRequiredAttributesAfterPending = {
  "asset.description": { descriptionRequired: "Description is required before the Firearm can go into service" },
  "asset.manufacturer": { manufacturerRequired: "Manufacturer is required before the Firearm can go into service" },
  "asset.model": { modelRequired: "Model is required before the Firearm can go into service" },
  "asset.purchaseDate": { purchaseDateRequired: "Purchase Date is required before the Firearm can go into service" },
  "asset.purchasePrice": { purchasePriceRequired: "Purchase Price is required before the Firearm can go into service" },
  "asset.identityReference": { identityReferenceRequired: "Identity Reference (Serial Number) is required before the Firearm can go into service" }
};

function getDescendantProp(obj, desc) {
  var arr = desc.split(".");
  while (obj != null && arr.length && (obj = obj[arr.shift()]));
  return obj;
}

// Firearm validation
export function validateFirearmAbleToGoIntoService(firearm: Firearm): ValidationWarnings | null {
  const validationFunctions = [validateFirearmAgainstInServiceState];
  return executeEntityValidators(firearm, validationFunctions);
}
export function validateFirearm(firearm: Firearm): ValidationWarnings | null {
  const validationFunctions = [validateFirearmAgainstCurrentState];
  return executeEntityValidators(firearm, validationFunctions);
}
export function validateFirearmAgainstCurrentState(firearm: Firearm): ValidationWarnings | null {
  return validateFirearmAgainstState(firearm, firearm);
}
export function validateFirearmAgainstInServiceState(firearm: Firearm): ValidationWarnings | null {
  return validateFirearmAgainstState(firearm, {
    lifecycleState: 'IN_SERVICE'
  });
}

export function validateFirearmAgainstState(firearm: Firearm, newState?: Partial<Firearm>): ValidationWarnings | null {
  if (firearm == null) {
    return null;
  }
  if (newState == null) {
    newState = firearm;
  }
  
  var result: ValidationWarnings = {};

  if (newState.lifecycleState != 'PENDING' && !firearm.personalFirearm) {
    for (let attr of Object.keys(firearmAdditionalRequiredAttributesAfterPending)) {
      var value = getDescendantProp(firearm, attr);
      if (value == null) {
        var validationWarnings = firearmAdditionalRequiredAttributesAfterPending[attr];
        Object.assign(result, validationWarnings);
      }
    }
  }

  if (Object.keys(result).length == 0) {
    return null;
  }
  return result;
}
